<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 资讯动态轮播图 -->
    <DynamicBanner></DynamicBanner>
    <!-- 公司动态详情 -->
    <DynamicDetails :newsId="newsId"></DynamicDetails>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import DynamicBanner from "../../../../components/pc/Dynamic/DynamicBanner.vue";
import DynamicDetails from '../../../../components/pc/Dynamic/DynamicDetails.vue'

export default {
  setup() {
    return reactive({
      newsId: 0,
    });
  },
  components: {
    TopNav,
    ButtonNav,
    DynamicBanner,
    DynamicDetails
  },
  created() {
    this.newsId = this.$route.query.id;
  },
};
</script>

<style scoped>
</style>
